import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import ApartmentDetail from "@/pages/ApartmentDetail";
import SearchResults from "@/pages/SearchResults";
import LongStay from "@/pages/LongStay";
import Checkin from "@/pages/Checkin";
import BookingPaypal from "@/pages/BookingPaypal";
import Legal from "@/pages/Legal";
import { CookieBanner } from "@/components/CookieBanner";
import BookingSuccess from "@/pages/BookingSuccess";
import BookingCancel from "@/pages/BookingCancel";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminReset from "@/pages/admin/AdminReset";
import AdminDashboard from "@/pages/admin/AdminDashboard";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <CookieBanner />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/apartamento/:slug" element={<ApartmentDetail />} />
            <Route path="/disponibilidad" element={<SearchResults />} />
            <Route path="/estancias-largas" element={<LongStay />} />
            <Route path="/checkin/:bookingId" element={<Checkin />} />
            <Route path="/reserva/paypal" element={<BookingPaypal />} />
            <Route path="/legal/:page" element={<Legal />} />
            <Route path="/reserva/exito" element={<BookingSuccess />} />
            <Route path="/reserva/cancelada" element={<BookingCancel />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/reset" element={<AdminReset />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          </Routes>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
